import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./KingsGuard.module.css";
import GameTemplate from "../games/GameTemplate";
import WhackaMole from "../games/WhackaMole";
import GameWrapper from "../GameWrapper";
const KingsGuard = () => {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <GameWrapper backgroundImage="/KingsGuard.webp">
      <button
        onClick={() => handleButtonClick("/home")}
        className={`${styles.homeButton} ${styles.button}`}
      >
        Home
      </button>

      <button
        onClick={() => handleButtonClick("/map")}
        className={`${styles.mapButton} ${styles.button}`}
      >
        Map
      </button>

      <WhackaMole />
    </GameWrapper>
  );
};

export default KingsGuard;
